<template>
    <div class="container">
        <div class="news-wrap" v-if="detail">
            <h2 class="news-title"><span>新闻资讯</span></h2>
            <div class="news-table" v-if="!isMobile">
                <table>
                    <tr
                        v-for="(item,index) in newsData"
                        :key="index"
                        class="on-mouseover"
                        @click="clickTr($event,item)"
                    >
                        <td class="item-img">
                            <a class="item-img-link" href="'?id=' + item.id" v-if="item.imgUrl">
                                <img class="news-img" :src="handleImgUrl(item.imgUrl)">
                            </a>
                            <a class="item-img-link" href="'?id=' + item.id" v-if="!item.imgUrl">
                                <img class="news-img" :src="defaultImg">
                            </a>
                        </td>
                        <td class="item-title">
                            <a class="item-title-txt" :href="'?id=' + item.id">{{item.title}}</a>
                            <div class="item-content">{{item.keywords}}</div>
                        </td>
                        <td class="item-time">{{formatDate(item.publishDate)}}</td>
                    </tr>
                </table>
            </div>
            <div class="news-card" v-else >
                <div class="card" v-for="(item,index) in newsData" :key="index" @click="clickTr($event,item)">
                    <img :src="handleImgUrl(item.imgUrl)">
                    <div class="news-content">
                        <h4>{{item.title}}</h4>
                        <p>{{item.keywords}}</p>
                    </div>
                </div>
            </div>
            <Pagination v-bind:pageObj.sync="pageObj"></Pagination>
        </div>

        <div class="news_bg" id="news_bg" v-else>
            <a class="t_close" @click="closeDetail"></a>
            <div class="news_bg_desc">
                <div class="news_titles">
                    <h1>{{activenews.title}}</h1>
                    <div class="p1">
                        <span>编辑：{{activenews.editor}}</span>
                        <span>发布时间：{{formatDate(activenews.publishDate)}}</span>
                        <template
                            v-if="activenews && activenews.attachment && activenews.attachment.length > 0"
                        >
                            <span id="bid-attactment">
                                <template v-for="(file,index) in activenews.attachment">
                                    <a
                                        :href="file"
                                        style="margin-right: 4px;"
                                        v-bind:key="index"
                                    >附件{{index + 1}}</a>
                                </template>
                            </span>
                        </template>
                    </div>
                </div>
                <div class="news_con" v-html="activenews.content"></div>
            </div>
        </div>
    </div>
</template>

<style lang="less">
.news-wrap {
    padding: 1rem;
    .news-title {
        font-size: 32px;
        color: #333333;
        margin: 0 0 1em 0;
        font-weight: bold;
    }
    .news-table {
        min-height: 5.5rem;
        table {
            width: 100%;
            color: #333;
            text-align: left;
            border-top: 1px solid #e8e9ef;
        }
    }
    .item-img,
    .item-title,
    .item-time {
        padding: 0.15rem 0;
        border-bottom: 1px solid #e8e9ef;
        vertical-align: middle;
    }
    .item-img-link {
        display: block;
    }
    .item-img {
        width: 1.5rem;
    }
    .news-img {
        width: 1.2rem;
        height: 0.8rem;
    }
    .item-time {
        width: 0.8rem;
        padding-right: 0.08rem;
    }
    .item-title {
        width: 7.5rem;
        padding-right: 0.08rem;
    }
    .item-title-txt {
        font-size: 18px;
        line-height: 2em;
    }
    .item-content {
        color: #888;
        width: 7rem;
        margin-top: 0.05rem;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }
    .on-mouseover:hover {
        background: #fafafa;
        cursor: pointer;
    }
}
.news_bg {
    position: absolute;
    z-index: 100;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    background: #ffffff;
    overflow-y: scroll;
    .t_close {
        display: block;
        width: 0.5rem;
        height: 0.5rem;
        border-radius: 100%;
        background: url(../../images/icon/close.png) center center
            no-repeat #025fac;
        position: absolute;
        right: 0.4rem;
        top: 0.4rem;
    }
    .news_bg_desc {
        padding: 0.6rem 10.4%;
    }
    .news_titles {
        border-bottom: 1px solid #f8f8f8;
        text-align: center;
        padding-bottom: 0.3rem;
    }
    .news_titles h1 {
        font-size: 28px;
        color: #0e223c;
        margin-bottom: 0.2rem;
    }

    .news_titles .p1 {
        line-height: 0.24rem;
    }

    .news_titles .p1 span {
        margin: 0 0.2rem;
        display: inline-block;
        font-size: 12px;
        color: #999;
    }
    .news_con {
        padding: 0.2rem;
        margin: 0.2rem 0;
        line-height: 0.3rem;
        font-size: 14px;
        text-align: justify;
    }

    .news_con p {
        margin-bottom: 0.05rem;
    }

    .news_con p img {
        margin: 0.1rem auto;
    }
    .news_con { h1, h2, h3, p { margin: 1em 0;} h1,h2,h3,strong {font-weight: bold;} }
}

@media screen and (min-width: 840px) and (max-width: 1079px) {
    .news-wrap {
        .news-title {
            font-size: 28px;
        }
        .news-table {
            font-size: 14px;
        }
        .item-title-txt {
            font-size: 16px;
        }
    }
}

@media screen and (min-width: 481px) and (max-width: 839px) {
    .news-wrap {
        .news-title {
            font-size: 24px;
        }
        .news-table {
            font-size: 12px;
        }
        .item-title-txt {
            font-size: 14px;
        }
    }
}

@media screen and (max-width: 480px) {
    .news-wrap {
        padding: 0.15rem 0;
        min-height: 3rem;
        .news-title {
            width: 100%;
            font-size: 16px;
            margin: 0 0 .1rem 0;
            text-align: center;
            color: #666;
            &:after {
                content: none;
            }
        }
        .news-card {
            border-top: 1px solid #e6e6e6;
        }
        .card {
            width: 100%;
            display: flex;
            border-bottom: 1px solid #e6e6e6;
            img {
                height: .6rem;
                width: .8rem;
                margin: 0.1rem;
            }
        }
        .news-content {
            padding: 0.05rem 0.1rem .05rem 0;
            display: flex;
            flex-direction: column;
            flex-flow: wrap;
            h4 {
                font-size: 14px;
                margin: 0.05rem 0;
                line-height: 1.2em;
                color: #333;
                flex: 0 2 auto;
                width: 100%;
            }
            p {
                font-size: 12px;
                flex: 0 1 auto;
            }
        }
    }
    .news_bg {
        .t_close {
            width: 0.3rem;
            height: 0.3rem;
            background-size:50% 50%; 
            right: 0.3rem;
            top: 0.2rem;
        }
        .news_bg_desc {
            padding: 0.6rem 0.3rem;
        }

        .news_titles h1 {
            font-size: 16px;
        }

        .news_titles .p1 {
            line-height: 0.24rem;
        }

        .news_titles .p1 span {
            margin: 0 0.1rem;
            display: inline-block;
            font-size: 12px;
            color: #999;
        }

        .news_con {
            padding: 0;
            margin: 0.2rem 0;
            font-size: 12px;
        }
    }
}
</style>

<script>
import Pagination from '../common/pagination';
import config from '@/config/env.js';
export default {
    metaInfo: {
        title: '安得智联-新闻资讯',
        meta: [{                 // set meta
            name: 'keyWords',
            content: '安得智联新闻资讯'
        },{                 // set meta
            name: 'description',
            content: '安得智联新闻资讯,发布高价值物流动态和招商资讯.'
        }]
    },
    data() {
        return {
            curPage: 1,
            isMobile: this.COMMON.isMobile,
            pageObj: {
                curPage: 1,
                pagesize: 10,
                total: 0
            },
            newsData: [],
            detail: true,
            activenews: {},
            defaultImg:require('../../images/picture/default.png')
        };
    },
    computed: {
        page: function() {
            return this.pageObj.curPage;
        }
    },
    activated() {
        this.getData(1);
    },
    methods: {
        initRouter() {
            if (this.$route.query && this.$route.query.id) {
                let item = this.newsData ? this.newsData.filter((item) => item.id === this.$route.query.id *1) : [];
                if (item && item[0]) {
                    this.showDetail(item[0]);
                }
            }
        },
        getData(page) {
            var self = this;
            this.$http
                .get(`${config.reqiestUrl}/api-portal/public/portal/news/page`, {
                    params: {
                        pageNo: page,
                        pageSize: self.pageObj.pagesize,
                        rmd: new Date().getTime()
                    }
                })
                .then(function(response) {
                    if (
                        response.data &&
                        response.data.data &&
                        response.data.data.list
                    ) {
                        self.newsData = response.data.data.list;
                        self.pageObj.total = response.data.data.totalCount;
                        self.initRouter();
                    }
                });
        },
        handleImgUrl(data) {
            if (data && data.startsWith('http')) {
                return data;
            } else {
                return '//www.annto.com' + data;
            }
        },
        // 新闻预览数量统计
        newsCount(data) {
            this.$http.post(`${config.reqiestUrl}/api-portal/public/portal/news/count`, data).then();
        },
        formatDate(date) {
            if(date) {
                return date.split(' ')[0];
            }
        },
        numToString(number) {
            return number >= 10 ? number.toString() : '0' + number;
        },
        clickTr(e, item) {
            this.newsCount(item);
            e.preventDefault();
            this.showDetail(item);
        },
        showDetail(item) {
            window.scroll(0, 0);
            document.body.style.overflow = 'hidden';
            this.$router.push({name: 'news', query: {id: item.id}});
            this.detail = false;
            this.activenews = item;
        },
        closeDetail() {
            document.getElementById('news_bg').scrollTop=0;
            this.$router.back(-1);
            document.body.style.overflow = 'auto';
            this.detail = true;
        }
    },
    watch: {
        $route(){
            if (!this.$route.query || !this.$route.query.id) {
                this.detail = true;
                document.body.style.overflow = 'auto';
                document.getElementById('news_bg')?document.getElementById('news_bg').scrollTop=0:'';
            }
        },
        page: function(page) {
            this.getData(page);
        }
    },
    components: {
        Pagination
    }
};
</script>